var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSevrdighedflora(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#746d51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.6,7.647a9.007,9.007,0,0,0-4.267,3.438L8.264,8.432a3.791,3.791,0,0,1-.936,0l-.067,2.653A9.013,9.013,0,0,0,2.993,7.647c.043,1.071,2.468,4.862,4.23,4.948l-.008.281c0,.57,1.161.57,1.161,0L8.369,12.6C10.131,12.509,12.555,8.718,12.6,7.647Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.8,8.027a3.956,3.956,0,0,0,3.728-4,2.37,2.37,0,0,0-2.047.951A3.513,3.513,0,0,0,7.8,2.265,3.51,3.51,0,0,0,6.115,4.976a2.373,2.373,0,0,0-2.048-.951A3.956,3.956,0,0,0,7.8,8.027Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSevrdighedflora);
export default __webpack_public_path__ + "static/media/SEVÆRDIGHED FLORA.945dccd6ea62522434bbceb54b885b6e.svg";
export { ForwardRef as ReactComponent };